<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button previousPageTitle="OAuth2 Scopes" previousPageUrl="/scopes" />
    </glxy-page-nav>
    <glxy-page-title>Create OAuth2 Scope</glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <h2 class="mat-h2 attention-header">ATTENTION</h2>
    <div class="mat-body attention-body">
      Creating new scopes should
      <strong>RARELY</strong>
      be done. First check if the scope you intend to create already exists. If you know you have a valid use case and
      have
      <a class="docs-link" href="https://github.com/vendasta/vendastaapis/blob/master/SCOPES.md#company-standards">
        read the relevant docs
      </a>
      , proceed. If you are unsure about anything consult with Teamy/Infrastructure.
    </div>
    <mat-card appearance="outlined">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field>
          <input placeholder="scope-id" formControlName="id" matInput />
        </mat-form-field>
        <mat-form-field>
          <input placeholder="Name" formControlName="name" matInput />
        </mat-form-field>
        <mat-form-field>
          <input placeholder="Description" formControlName="description" matInput />
        </mat-form-field>
        <mat-card-actions>
          <button mat-flat-button color="primary" [disabled]="form.invalid || isDisabled">Save</button>
          <button mat-flat-button type="button" (click)="onCancel()">Cancel</button>
        </mat-card-actions>
      </form>
    </mat-card>
  </glxy-page-wrapper>
</glxy-page>
